module.exports = __webpack_public_path__ + "static/media/utility-room.098208f9.svg";